export default "__VITE_ASSET__CwwUvhwt__"